import React, { FC } from 'react';
import { Grid, Typography,Theme } from '@mui/material';
import moment from 'moment';
import { makeStyles } from '@mui/styles';

interface MonthLabelsProps {
    calendarDate: moment.Moment | undefined;
    daysToShow: number;
}

const useStyles = makeStyles((theme:Theme) => ({
    monthLabel: {
      fontFamily: 'Open Sans !important',
      fontSize: "14px !important",
      color: "#2b2b2b!important",
      fontWeight: "700 !important",
      textAlign: 'center',
    },
  }));

const MonthLabels: FC<MonthLabelsProps> = ({ calendarDate, daysToShow }) => {
    const classes = useStyles();
    const firstDate = calendarDate?.clone();
    const lastDate = calendarDate?.clone().add(daysToShow - 1, 'days');

    const firstMonth = firstDate?.format('MMMM');
    const firstMonthYear = firstDate?.format('YYYY');
    const lastMonth = lastDate?.format('MMMM');
    const lastMonthYear = lastDate?.format('YYYY');

    if (firstMonth !== lastMonth) {
        return (
            <Grid container sx={{ display: "flex", justifyContent: "center", gap: "5px" }}>
                <Grid item className={classes.monthLabel}>
                    <Typography>{`${firstMonth} ${firstMonthYear}`}</Typography>
                </Grid>
                 <Grid item className={classes.monthLabel}>
                    <Typography>-</Typography>
                </Grid>
                <Grid item className={classes.monthLabel}>
                    <Typography>{`${lastMonth} ${lastMonthYear}`}</Typography>
                </Grid>
            </Grid>
        );
    } else {
        return (
            <Grid container justifyContent="center">
                <Grid item className={classes.monthLabel}>
                 <Typography>{`${firstMonth} ${firstMonthYear}`}</Typography>
                </Grid>
            </Grid>
        );
    }
};

export default MonthLabels;
